// hooks/useOrderCheckout.js
import { useState } from 'react';
import { orderCheckout } from '../services/courseOrder';
import toast from 'react-hot-toast';


export const useOrderCourseCheckout = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitOrder = async (contactData, userEmail) => {
    setIsSubmitting(true);
    try {
      const response = await orderCheckout(contactData, userEmail);
      toast.success('Order submitted successfully!', {
        position: "top-right",
        autoClose: 3000
      });
      return response;
    } catch (error) {
      toast.error(error?.message || 'Failed to submit order', {
        position: "top-right",
        autoClose: 3000
      });
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submitOrder, isSubmitting };
};
